import { createFileRoute } from '@tanstack/react-router';
import { TranscriptPage } from '../../../pages/tools/transcript/TranscriptPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/youtube-transcript')({
  head: () => toolHead('youtube-transcript'),
  component: () => <TranscriptPage platform="youtube" />,
});
